export { v4 as uuidv4 } from "uuid";

function guid(length = 8) {
	function s4() {
		return Math.floor((1 + Math.random()) * 0x10000)
			.toString(16)
			.substring(1);
	}
	switch (length) {
		case 32:
			return s4() + s4() + "-" + s4() + "-" + s4() + "-" + s4() + "-" + s4() + s4() + s4();
		default:
			return s4() + s4();
	}
	// return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
	//        s4() + '-' + s4() + s4() + s4();
}

export default guid;
